import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bcd49bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "field name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Nome", -1))
const _hoisted_4 = { class: "field description" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Descrição", -1))
const _hoisted_6 = { class: "type" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Tipo", -1))
const _hoisted_8 = { class: "rules" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Regras", -1))
const _hoisted_10 = { class: "items" }
const _hoisted_11 = { class: "list-rules" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "add-item" }
const _hoisted_14 = { class: "messages" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Mensagem", -1))
const _hoisted_16 = { class: "message-details" }
const _hoisted_17 = {
  key: 0,
  class: "field"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Para", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Texto", -1))
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Ações", -1))
const _hoisted_23 = { class: "checkbox" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviar Mensagem", -1))
const _hoisted_25 = { class: "checkbox" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mostrar Alarme", -1))
const _hoisted_27 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SelectType = _resolveComponent("SelectType")!
  const _component_RuleCard = _resolveComponent("RuleCard")!
  const _component_SelectUser = _resolveComponent("SelectUser")!
  const _component_ModalRule = _resolveComponent("ModalRule")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Gatilho",
    isActive: _ctx.show,
    onCloseModalClick: _ctx.closeModal,
    size: "large"
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-screwdriver-wrench" })
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formTrigger.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formTrigger.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("textarea", {
            class: "textarea",
            rows: "5",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formTrigger.description) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formTrigger.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_SelectType, {
            selectedType: _ctx.formTrigger.type,
            onOnSelectType: _ctx.selectType
          }, null, 8, ["selectedType", "onOnSelectType"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formTrigger.rules, (rule, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-item",
                  key: index
                }, [
                  _createVNode(_component_RuleCard, { rule: rule }, null, 8, ["rule"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "button remove-rule",
                      onClick: ($event: any) => (_ctx.removeRule(index))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                    ], 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "button add-rule",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)))
              }, "Adicionar Regra")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_ctx.formTrigger.actions.includes('send_message'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_SelectUser, {
                    users: _ctx.formSendTo,
                    onOnSelectUsers: _ctx.addSendTo
                  }, null, 8, ["users", "onOnSelectUsers"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                class: "textarea",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formTrigger.message) = $event))
              }, null, 512), [
                [_vModelText, _ctx.formTrigger.message]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: "send_message",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formTrigger.actions) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formTrigger.actions]
                ]),
                _hoisted_24
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  value: "show",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formTrigger.actions) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formTrigger.actions]
                ]),
                _hoisted_26
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ModalRule, {
        isActive: _ctx.showRuleModal,
        onCloseModalClick: _ctx.closeRuleModal,
        onOkModalClick: _ctx.saveRule
      }, null, 8, ["isActive", "onCloseModalClick", "onOkModalClick"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          class: "button delete-button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "Cancelar"),
        _createElementVNode("button", {
          class: "button save-button",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, "Salvar")
      ])
    ]),
    _: 1
  }, 8, ["isActive", "onCloseModalClick"]))
}